import { Box, Stack, styled, Typography } from '@mui/material';
import { theme } from '../../../theme/theme';
import { Link as MuiLink } from '@mui/material';

export const StackContainer = styled(Stack)({
  boxSizing: 'border-box',
  width: '100%',
  minHeight: '100vh',
  position: 'relative',
  overflow: 'hidden',
  padding: 0,
  margin: 0,
  backgroundColor: theme.palette.white.main,
});

export const ProfileWrapper = styled(Stack)(({ theme }) => ({
  width: '100%',
  maxWidth: '1750px',
  margin: '0 auto',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  [theme.breakpoints.up('lg')]: {
    minWidth: 'unset',
  },
  [theme.breakpoints.down('md')]: {
    minWidth: 'unset',
    maxWidth: '100%',
  },
}));

export const TitleContainer = styled(Box)({
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: '44px',
  [theme.breakpoints.down('sm')]: {
    marginTop: '80px',
  },
});

export const TitleText = styled(Typography)(({ theme }) => ({
  marginLeft: '20px',
  fontWeight: theme.typography.signInWelcome.fontWeight,
  color: theme.palette.primary.main,
  fontSize: theme.typography.h1.fontSize,
  [theme.breakpoints.down('md')]: {
    fontSize: theme.typography.profile.fontSize,
    marginLeft: '0px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.titleText.fontSize,
    marginLeft: '0px',
  },
}));

export const BodyContainer = styled(Stack)(({ theme }) => ({
  borderRadius: '1rem',
  overflow: 'hidden',
  marginTop: '16px',
  marginBottom: '1rem',
  width: '100%',
  justifyContent: 'center',
  gap: '0rem',
  flexDirection: 'row',
  flexGrow: 1,
  [theme.breakpoints.down('md')]: {
    marginTop: '-6px',
    gap: '1rem',
    flexDirection: 'column',
  },
  [theme.breakpoints.down('sm')]: {
    marginTop: '-16px', // <- menor que en tablet
  },
  [theme.breakpoints.up('md')]: {
    marginBottom: '1rem',
  },
}));

export const ProfileInfoContainer = styled(Stack)(({ theme }) => ({
  maxWidth: '40%',
  margin: '0 auto',
  boxSizing: 'border-box',
  flexDirection: 'column',
  padding: 'clamp(1rem, -1.8571rem + 12.1905vw, 2rem)',
  justifyContent: 'start',
  alignItems: 'center',
  flex: 1,
  padding: 'clamp(1rem, -1.8571rem + 12.1905vw, 2rem)',
  marginTop: '20px',
  [theme.breakpoints.down('md')]: {
    maxWidth: '100%',
    paddingTop: 0,
  },
}));

export const ProfileImageBox = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '1rem 0',
  [theme.breakpoints.up('md')]: {
    width: '100%',
  },
}));

export const TitleStepeBox = styled(Box)(({ theme }) => ({
  width: '100%',
  height: 'auto',
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'center',
  [theme.breakpoints.up('sm')]: {
    marginTop: '0px',
  },
  [theme.breakpoints.between('sm', 'md')]: {
    marginTop: '20px',
  },
  [theme.breakpoints.up('md')]: {
    width: '80%',
    minHeight: '180px',
  },
}));

export const ProfileActionsBox = styled(Stack)(({ theme }) => ({
  width: '100%',
  maxWidth: '60%',
  margin: '0 auto',
  boxSizing: 'border-box',
  flexDirection: 'column',
  padding: 'clamp(1rem, -1.8571rem + 12.1905vw, 2rem)',
  justifyContent: 'center',
  alignItems: 'center',
  gap: theme.spacing(1),
  [theme.breakpoints.down('md')]: {
    maxWidth: '100%',
    marginTop: 0,
  },
  [theme.breakpoints.down('sm')]: {
    marginTop: '2rem',
  },
}));

export const RiskOptionsStack = styled(Stack)(({ theme }) => ({
  width: '100%',
  flexDirection: 'column',
  gap: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    gap: theme.spacing(1),
    marginTop: '-40px',
  },
}));

export const HelpLinkStack = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  display: 'flex',
  textAlign: 'center',
  alignItems: 'center',
  marginTop: '24px',
}));

export const StyledHelpLink = styled(MuiLink)(({ theme }) => ({
  fontSize: '1rem',
  marginLeft: '6px',
  fontWeight: 600,
  cursor: 'pointer',
  [theme.breakpoints.down('md')]: {
    fontSize: '1rem',
  },
}));

export const ButtonsStack = styled(Stack)(({ theme }) => ({
  width: '100%',
  margin: '2rem auto 0',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'stretch',
  gap: theme.spacing(1),
  [theme.breakpoints.between('sm', 'md')]: {
    gap: theme.spacing(3),
    justifyContent: 'space-around',
  },
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column-reverse',
    gap: theme.spacing(2),
    marginTop: theme.spacing(2.5),
  },
}));

export const IconsRiskProfile = styled('img')(({ theme }) => ({
  width: '80px',
  height: '80px',
  objectFit: 'contain',
  display: 'block',
  [theme.breakpoints.up('md')]: {
    width: '120px',
    height: '120px',
  },
}));
